export enum CompanySizes {
	ONE_TEN = '1-10',
	ELEVEN_FIFTY = '11-50',
	FIFTYONE_HUNDRED = '51-100',
	HUNDREDONE_FIVEHUNDRED = '101-500',
	FIVEHUNDREDONE_THOUSAND = '501-1000',
	MORE_THAN_THOUSAND = 'More than 1000'
}
